import React, { Fragment, useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Spinner, ModalFooter } from 'reactstrap';
import close from '../../../../assets/V2-images/close.svg';
import BasicTree from 'components/Dam/FolderTree';
import { Addfolder, folderdata, MOVE_TO_ASSET_DATA } from 'components/Dam/DAM_API/urls';
import Axios, { header } from 'functions/Axios';
import { DAM_SVG } from 'components/Dam/DamAssets';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import CommonThreeDotSvg from '../CommonThreeDotSvg';
import { ButtonC } from 'Common/Buttons';
import { toast } from 'react-toastify';
import WordWrapEllipse from 'components/Dam/WordWrapEllipse';
import InputC from 'Common/Inputs/index.tsx';
import { useSelector } from 'react-redux';

const MoveToAssetDesign = ({
  OpenModal = false,
  ToggleModal,
  Data,
  isMultiple = false,
  HandleAssetMove,
  HandleMoveFunctionality,
  HandleFolderCreation,
}) => {
  const [selectedFoldersData, setSelectedFoldersData] = useState();
  const [insideFolderData, setInsideFolderData] = useState();
  const [insideFolderImageData, setInsideFolderImageData] = useState();
  const [activeId, setActiveId] = useState();
  const [selectedDamFileId, setSelectedDamFileId] = useState();
  const [folderModalOpen, setFolderModalOpen] = useState(false);
  const { HierarchyFolderData } = useSelector((state) => state.dam);

  const [folderName, setFolderName] = useState();
  const [loaders, setLoaders] = useState({
    moving: false,
    folder: false,
  });

  const closeBtn2 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => ToggleModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const moveToAssetHandler = async (value) => {
    try {
      if (HandleMoveFunctionality) {
        HandleMoveFunctionality(value ?? selectedDamFileId);
        return;
      }
      setLoaders((prev) => ({
        ...prev,
        moving: true,
      }));
      const body = {
        targetAssetId: value?.id ?? selectedDamFileId?.id ?? null,
        sourceAssetId: isMultiple ? Data : [Data],
      };

      // if (!body.targetAssetId) {
      //   toast.error('Please select a folder first');
      //   return;
      // }

      const { data } = await Axios.post(MOVE_TO_ASSET_DATA, body, header);
      toast.success(data?.message ?? '');
      setLoaders((prev) => ({
        ...prev,
        moving: false,
      }));
      ToggleModal(false); // close modal on success
      HandleAssetMove && HandleAssetMove();
    } catch (error) {
      setLoaders((prev) => ({
        ...prev,
        moving: false,
      }));
      console.error(error);
    }
  };

  const createFolderHandler = async () => {
    try {
      setLoaders((prev) => ({
        ...prev,
        folder: true,
      }));
      const formData = new FormData();
      formData.append('folderName', folderName);
      formData.append('parentFolderId', selectedDamFileId?.id);

      const response = await Axios.post(Addfolder, formData);
      HandleFolderCreation && HandleFolderCreation();
      getFolderData();
      setFolderModalOpen(!folderModalOpen);
      toast.success(response?.data?.message);
      setFolderName('');
      setLoaders((prev) => ({
        ...prev,
        folder: false,
      }));
    } catch (err) {
      setLoaders((prev) => ({
        ...prev,
        folder: false,
      }));
      console.error(err);
      toast.error(err.response.data.message);
    }
  };

  const getFolderData = async () => {
    try {
      const { data } = await Axios.get(folderdata + `?pageNo=${0}&rowSize=100`);
      const traverseData = data?.data?.folders?.flatMap((item) => item?.folders);
      setSelectedFoldersData(
        traverseData?.map((item) => ({
          ...item,
          isFirstFolder: true,
        })),
      );
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        getFolderData();
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return (
    <Fragment>
      <Modal
        isOpen={OpenModal}
        toggle={ToggleModal}
        style={{ maxWidth: '784px', width: '784px', maxHeight: '70vh', overflow: 'auto' }}
      >
        <div
          style={{
            backgroundColor: folderModalOpen ? '#1e293b66' : 'transparent',
          }}
        >
          <ModalHeader toggle={ToggleModal} close={closeBtn2}>
            Moving
          </ModalHeader>
          <ModalBody
            style={{
              position: 'relative',
            }}
          >
            {/* <div className="d-flex gap-2">
              {HierarchyFolderData?.map((item, index) => (
                <div
                  className={
                    index === HierarchyFolderData?.length - 1
                      ? 'hierarchy_active_tab'
                      : 'hierarchy_inactive_tab'
                  }
                >
                  {index > 0 && '/'} {item?.folderName}
                </div>
              ))}
            </div> */}
            <div className="d-flex gap-2" style={{ height: '50vh', overflow: 'auto' }}>
              {/* Left Side (Tree) */}
              <div style={{ width: '25%' }}>
                <BasicTree
                  FolderData={selectedFoldersData}
                  HandleSelectPerticularFOlder={(value) => {
                    setSelectedDamFileId(value);
                  }}
                  HandleInsideData={(value) => {
                    setInsideFolderData(value?.folders?.[0]?.subfolders);
                    setInsideFolderImageData(value?.images);
                  }}
                />
              </div>

              {/* Right Side (Inside Folder) */}
              <div
                style={{
                  width: '75%',
                  borderLeft: '1px solid #e0e0e0',
                  padding: '0px 1rem',
                  overflow: 'auto',
                }}
              >
                {insideFolderData?.map((item, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between inner_folder_hovered_data"
                  >
                    <div className="d-flex gap-2 align-items-center">
                      {DAM_SVG.openFolderSvgIcon}
                      <span className="visible_folder_header">{item?.folderName}</span>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <CommonSidePortal
                        activeId={activeId}
                        setActiveId={setActiveId}
                        portalId={index}
                        ViewSection={<CommonThreeDotSvg />}
                        Right={'0px'}
                        preferredSide="left"
                        OpenSection={
                          <div className="">
                            <div
                              className="d-flex align-items-center gap-2 pointer"
                              onClick={() => {
                                moveToAssetHandler(item);
                              }}
                            >
                              <p className="list_cart">Move Here</p>
                            </div>
                            {/* <div className="d-flex align-items-center gap-2 pointer">
                              <p className="list_cart">Open/Go Inside</p>
                            </div> */}
                          </div>
                        }
                      />
                    </div>
                  </div>
                ))}
                {insideFolderImageData?.map((item, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between inner_folder_hovered_data"
                  >
                    <div className="d-flex gap-2 align-items-center">
                      {DAM_SVG.assetsViewIconSvg}
                      <span className="visible_folder_header">
                        {' '}
                        <WordWrapEllipse Text={item?.assetName} />{' '}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-3">
              <div>
                <ButtonC
                  text={
                    <div className="d-flex gap-1 align-items-center">
                      <div className="d-flex">{DAM_SVG.folderAddition}</div>
                      <div> New Folder</div>
                    </div>
                  }
                  color="Tertiary"
                  click={() => {
                    setFolderModalOpen(!folderModalOpen);
                  }}
                  size="lg"
                />
              </div>
              <div>
                <ButtonC text="Cancel" color="Secondary" click={ToggleModal} size="lg" />
              </div>
              <div>
                {/* Submit button -> Enter key also triggers this */}
                <ButtonC
                  text=""
                  type="submit"
                  size="lg"
                  click={() => {
                    moveToAssetHandler();
                  }}
                  disabled={loaders.moving}
                >
                  {loaders?.moving && <Spinner color="light" className="mx-1" size="sm" />} Move
                  Here
                </ButtonC>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
      <Modal isOpen={folderModalOpen} style={{ width: '50vw' }}>
        <ModalHeader title="Create New Folder" toggle={() => setFolderModalOpen((pre) => !pre)}>
          Create New Folder
        </ModalHeader>
        <ModalBody>
          <div>
            <InputC
              type="text"
              placeholder=""
              size="lg"
              label="Folder Name"
              change={(e) => {
                setFolderName(e.target.value);
              }}
              inputvalue={folderName}
            />
          </div>
        </ModalBody>
        <ModalFooter style={{ border: 'none' }}>
          <div
            className="Primary-Button large-button"
            onClick={(e) => {
              e.stopPropagation();
              createFolderHandler();
            }}
            disabled={loaders?.folder}
          >
            {loaders?.folder && <Spinner color="light" className="mx-1" size="sm" />} Create
          </div>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default MoveToAssetDesign;
